import axios from "axios";
import interceptors from "@/shared/api/interceptors";
window.domain = window.__CONFIG__.VUE_APP_BASE_DOMAIN;
const apiClient = axios.create({
  baseURL: window.domain + "/auth",
  withCredentials: true,
});

interceptors(apiClient);
export default apiClient;
